// Deutsch — mirrors en.js key for key. de distinguishes one/other in CLDR.
const de = {
  // ===== shared =====
  'common.createPlan': 'Plan erstellen',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.retry': 'Erneut versuchen',
  'common.activate': 'Aktivieren',
  'common.deactivate': 'Deaktivieren',
  'common.enabled': 'Aktiviert',
  'common.disabled': 'Deaktiviert',
  'common.viewTerms': 'Bedingungen ansehen',
  'common.untitledPlan': 'Unbenannter Plan',
  'common.savedToast': 'Erfolgreich gespeichert',

  // ===== nav / chrome =====
  'nav.home': 'Startseite',
  'nav.plans': 'Pläne',
  'nav.settings': 'Einstellungen',

  'mismatch.title': 'Bereitstellungsumgebung stimmt nicht überein',
  'mismatch.body': 'Dieser Frontend-Build ruft {apiBase} auf, wird aber von {hostname} ausgeliefert (erwartet: {expected}).',
  'mismatch.contact': 'Bitte wenden Sie sich an den technischen Support — dies ist ein Konfigurationsfehler bei der Bereitstellung, kein Problem mit Ihrem Konto.',

  'install.title': 'Verbindung zu Shopify konnte nicht hergestellt werden',
  'install.body': 'Prüfen Sie, ob das Backend läuft und ob sein SHOPIFY_API_KEY mit der client_id der App in shopify.app.toml übereinstimmt.',
  'install.retry': 'Erneut versuchen',

  'chrome.loadingBrand': 'FlexCover wird geladen…',
  'error.title': 'Etwas ist schiefgelaufen',
  'error.reload': 'Neu laden',

  'support.badge': 'Support-Ansicht',
  'support.shopUnknown': '(unbekannter Shop)',
  'support.expired': 'Token abgelaufen — bitte in der Support-Konsole neu generieren',
  'support.validUntil': 'Token gültig bis {time}',
  'support.exit': 'Beenden',

  // ===== Home =====
  'home.title': 'Willkommen bei FlexCover: Protection Plans 👋',
  'home.last30days': 'Letzte 30 Tage',
  'home.loadingChart': 'Diagramm wird geladen',
  'home.loadingOverview': 'Übersicht wird geladen',
  'home.statOrders': 'Bestellungen mit Plänen',
  'home.statRevenue': 'Gesamterlös aus Plänen',
  'home.gettingStarted': 'Erste Schritte',
  'home.allSet': 'Alles erledigt 🎉',
  'home.completed': '{done} von {total} abgeschlossen',
  'home.step1.title': 'Erstellen Sie Ihren ersten Plan',
  'home.step1.desc': 'Legen Sie Preis, Deckung und Warenkorb-Darstellung für Ihr Schutzangebot fest.',
  'home.step2.title': 'App-Embed aktivieren',
  'home.step2.desc': 'Aktivieren Sie den Block „FlexCover: Protection Plans“, damit das Widget in Ihrem Warenkorb erscheint.',
  'home.step2.enable': 'App-Embed aktivieren',
  'home.step2.check': 'Status prüfen',
  'home.step3.title': 'Erhalten Sie Ihre erste geschützte Bestellung',
  'home.step3.desc': 'Ist das Widget live, fügen Kunden im Warenkorb einen Plan hinzu — die Summen erscheinen in den Karten oben.',
  'home.appEmbed': 'App-Embed',
  'home.checkingEmbed': 'App-Embed-Status wird geprüft',
  'home.embedEnabledBody': 'Das Schutz-Widget ist auf Ihrer Storefront live.',
  'home.embedTheme': '(Theme: {theme})',
  'home.embedDisabledBody': 'Die App ist derzeit auf Ihrer Storefront nicht aktiv.',
  'home.embedUnknown': 'Unbekannt',
  'home.embedUnknownBody': 'Der Storefront-Status ist verfügbar, sobald die App mit einem Shop verbunden ist.',
  'home.embedUnknownReason': 'Ihr Live-Theme konnte gerade nicht gelesen werden.',
  'home.enableEmbedHint': 'Gehen Sie im Shopify-Admin zu Onlinestore → Themes → Anpassen → App-Embeds und schalten Sie FlexCover: Protection Plans ein.',
  'home.learnMorePrefix': 'Erfahren Sie mehr über ',
  'home.learnMoreLink': 'die Verwendung von Schutzplänen',

  // ===== Plans list =====
  'plans.title': 'Pläne',
  'plans.loading': 'Pläne werden geladen',
  'plans.errorTitle': 'Pläne konnten nicht geladen werden',
  'plans.empty.heading': 'Erstellen Sie Ihren ersten Schutzplan',
  'plans.empty.body': 'Bieten Sie Versandversicherung, erweiterte Garantien, Rückgabeversicherung und individuelle Deckung an — alles mit Ihrer Preisgestaltung.',
  'plans.loadDemo': 'Demo-Pläne laden',
  'plans.demoLoaded': 'Demo-Pläne geladen',
  'plans.demoFailed': 'Demo-Pläne konnten nicht geladen werden: {message}',
  'plans.filterPlaceholder': 'Pläne filtern',
  'plans.addFilter': 'Filter hinzufügen',
  'plans.statusHeading': 'Status',
  'plans.typeHeading': 'Schutztyp',
  'plans.statusActive': 'Aktiv',
  'plans.statusInactive': 'Inaktiv',
  'plans.showing_one': '{count} Plan angezeigt',
  'plans.showing_other': '{count} Pläne angezeigt',
  'plans.sortBy': 'Sortieren nach',
  'plans.selectAll': 'Alle Pläne auswählen',
  'plans.selectedCount': '{count} ausgewählt',
  'plans.bulkDeleted_one': '{count} Plan gelöscht',
  'plans.bulkDeleted_other': '{count} Pläne gelöscht',
  'plans.bulkActivated_one': '{count} Plan aktiviert',
  'plans.bulkActivated_other': '{count} Pläne aktiviert',
  'plans.bulkDeactivated_one': '{count} Plan deaktiviert',
  'plans.bulkDeactivated_other': '{count} Pläne deaktiviert',
  'plans.deleteBulkFailed': 'Löschen fehlgeschlagen: {message}',
  'plans.updateBulkFailed': 'Aktualisierung fehlgeschlagen: {message}',
  'plans.activated': 'Plan aktiviert',
  'plans.deactivated': 'Plan deaktiviert',
  'plans.updateFailed': 'Plan konnte nicht aktualisiert werden: {message}',
  'plans.deleted': 'Plan gelöscht',
  'plans.deleteFailed': 'Plan konnte nicht gelöscht werden: {message}',
  'plans.actionsFor': 'Aktionen für {name}',
  'plans.activatePlan': '{name} aktivieren',
  'plans.deactivatePlan': '{name} deaktivieren',
  'plans.onlineStore': 'Onlinestore',
  'plans.optional': 'Optional',
  'plans.automatic': 'Automatisch',
  'plans.noMatch': 'Keine Pläne entsprechen Ihrer Suche oder Ihren Filtern.',
  'plans.deleteTitle': 'Schutzplan löschen?',
  'plans.deleteBody': 'wird sofort aus Ihrem Shop entfernt. Kunden sehen diese Schutzoption nicht mehr.',
  'plans.helpPrefix': 'Brauchen Sie Hilfe? ',
  'plans.helpLink': 'Schreiben Sie uns',
  'plans.helpSuffix': ' oder sehen Sie sich die Dokumentation und Tutorials der App an.',

  'sort.date': 'Datum (neueste zuerst)',
  'sort.name': 'Name (A–Z)',
  'sort.sortOrder': 'Warenkorb-Reihenfolge',
  'sort.price': 'Preis (aufsteigend)',

  'planType.shipping_protection': 'Versandversicherung',
  'planType.warranty': 'Garantie',
  'planType.return_insurance': 'Rückgabeversicherung',
  'planType.custom': 'Individueller Schutz',
  'planTypeShort.shipping_protection': 'Versand',
  'planTypeShort.warranty': 'Garantie',
  'planTypeShort.return_insurance': 'Rückgabe',
  'planTypeShort.custom': 'Individuell',
  'priceType.fixed': 'Fester Betrag',
  'priceType.percentage': 'Prozentsatz der Bestellung',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Schutzplan',
  'plan.loading': 'Plan wird geladen',
  'plan.notFound.heading': 'Plan nicht gefunden',
  'plan.notFound.body': 'Dieser Schutzplan wurde möglicherweise gelöscht.',
  'plan.backToPlans': 'Zurück zu den Plänen',
  'plan.newTitle': 'Neuer Schutzplan',
  'plan.newSubtitle': 'Konfigurieren Sie Preis und Warenkorb-Darstellung und erstellen Sie dann den Plan',
  'plan.subtitle': 'Änderungen werden nach dem Speichern auf Ihren Shop angewendet',
  'plan.statusTitle': 'Planstatus',
  'plan.saveFailed': 'Plan konnte nicht gespeichert werden: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Schutztyp',
  'form.section.basics': 'Plan-Grunddaten',
  'form.section.pricing': 'Preisgestaltung – {type}',
  'form.pricingFallback': 'Schutz',
  'form.section.appearance': 'Aussehen',
  'form.section.fulfillment': 'Erfüllung',

  'form.type.shipping_protection': 'Versandversicherung',
  'form.type.shipping_protection.help': 'Schützt die Bestellung des Kunden vor Verlust, Beschädigung oder Diebstahl beim Versand.',
  'form.type.warranty': 'Garantie',
  'form.type.warranty.help': 'Deckt Herstellungsfehler und normale Abnutzung für einen festen Zeitraum ab.',
  'form.type.return_insurance': 'Rückgabeversicherung',
  'form.type.return_insurance.help': 'Ermöglicht Kunden die Rückgabe von Artikeln innerhalb einer Frist mit voller Rückerstattung.',
  'form.type.custom': 'Individueller Schutz',
  'form.type.custom.help': 'Ihre eigene individuelle Schutzmeldung.',

  'form.defaults.untitledPlan': 'Unbenannter Plan',
  'form.defaults.viewTerms': 'Bedingungen ansehen',
  'form.defaults.shipping_protection.displayName': 'Versandversicherung',
  'form.defaults.shipping_protection.description': 'Schützt Ihre Bestellung vor Verlust, Beschädigung und Diebstahl beim Versand.',
  'form.defaults.warranty.displayName': 'Erweiterte Garantie',
  'form.defaults.warranty.description': 'Deckt Fabrikationsfehler und normale Abnutzung für 2 Jahre ab.',
  'form.defaults.return_insurance.displayName': 'Rückgabeversicherung',
  'form.defaults.return_insurance.description': 'Geben Sie Artikel innerhalb von 14 Tagen zurück — volle Rückerstattung.',
  'form.defaults.custom.displayName': 'Schutzplan',
  'form.defaults.custom.description': 'Fügen Sie Ihrer Bestellung Schutz hinzu.',

  'form.lang.select': 'Sprache auswählen',
  'form.lang.default': '{name} (Standard)',
  'form.translated': '(übersetzt)',

  'form.field.planName.label': 'Planname (intern)',
  'form.field.planName.help': 'Nur für Ihre Referenz — Kunden sehen dies nie',
  'form.field.nameRequired': 'Interner Name ist erforderlich',
  'form.field.displayName.label': 'Anzeigename',
  'form.field.displayNameRequired': 'Anzeigename ist erforderlich',
  'form.field.displayName.placeholder': 'Anzeigename',
  'form.field.displayName.help': 'Wird Kunden in Warenkorb und Checkout angezeigt',
  'form.field.displayName.helpPreset': 'Wird Kunden angezeigt, die auf {lang} stöbern',
  'form.field.displayName.helpPresetFallback': 'Wird Kunden angezeigt, die auf {lang} stöbern — leere Felder fallen auf {primary} zurück',
  'form.field.description.label': 'Beschreibung',
  'form.field.description.placeholder': 'Beschreibung',
  'form.field.description.help': 'Kurze kundengerichtete Beschreibung unter dem Plannamen',
  'form.field.disabledDescription.label': 'Beschreibung bei Nichtauswahl',
  'form.field.disabledDescription.placeholder': 'Optional — wird angezeigt, wenn der Plan nicht ausgewählt ist',
  'form.field.disabledDescription.help': 'Wird angezeigt, wenn das Kontrollkästchen des Plans deaktiviert ist (fällt bei Leerheit auf die obige Beschreibung zurück)',
  'form.field.footer.label': 'Fußzeile',
  'form.field.footerText.label': 'Fußzeilentext',
  'form.field.footerLink.label': 'Fußzeilenlink',
  'form.field.footerLink.help': 'Ziel des Fußzeilentext-Links',

  'form.price.type.label': 'Preistyp',
  'form.price.fixed': 'Betrag ($)',
  'form.price.percentage': 'Prozentsatz (%)',
  'form.price.advanced': 'Erweiterte Einstellung',
  'form.price.pctSummary': '{pct} % des Bestellwerts, ab ${min} in Schritten von ${inc} bis ${max} — {count} Varianten im Planprodukt',
  'form.price.tiersSummary_one': 'Das Planprodukt erhält 1 Variante zu {base} plus {count} Intervallvariante für die Warenkorbwert-Regeln',
  'form.price.tiersSummary_other': 'Das Planprodukt erhält 1 Variante zu {base} plus {count} Intervallvarianten für die Warenkorbwert-Regeln',

  'form.validation.priceRequired': 'Geben Sie einen Wert größer als 0 ein',
  'form.validation.priceMax100': 'Der Prozentsatz darf 100 nicht überschreiten',
  'form.validation.warrantyYears': 'Geben Sie eine Dauer zwischen 1 und 5 Jahren ein',
  'form.validation.returnDays': 'Geben Sie ein Zeitfenster zwischen 7 und 365 Tagen ein',
  'form.validation.maxGreaterThanMin': 'Der Maximalwert muss größer als der Minimalwert sein',
  'form.validation.variantIdNumeric': 'Die Varianten-ID muss numerisch sein (die ID der versteckten Planvariante)',

  'form.icon.label': 'Symbol',
  'form.icon.useEmoji': '{emoji} als Plansymbol verwenden',
  'form.icon.removeCustom': 'Benutzerdefiniertes Symbol entfernen und Schild-Symbol verwenden',
  'form.icon.upload': 'Benutzerdefiniertes Symbol hochladen',
  'form.icon.uploadButton': 'Hochladen',
  'form.icon.uploading': 'Symbol wird hochgeladen',
  'form.icon.uploadHelp': 'Laden Sie Ihr eigenes Symbol hoch — PNG, JPEG, GIF oder WebP, bis 5 MB.',
  'form.icon.error.notImage': 'Bitte wählen Sie eine Bilddatei (PNG, JPEG, GIF oder WebP).',
  'form.icon.error.tooLarge': 'Das Bild muss 5 MB oder kleiner sein.',

  'form.fulfillment.intro': 'Wählen Sie, wann das Schutzprodukt als erfüllt markiert wird.',
  'form.fulfillment.manually': 'Manuell erfüllen',
  'form.fulfillment.first_item': 'Als erfüllt markieren, wenn der erste Artikel der Bestellung erfüllt ist',
  'form.fulfillment.all_items': 'Als erfüllt markieren, wenn alle anderen Artikel der Bestellung erfüllt sind',
  'form.fulfillment.immediately': 'Sofort nach Bestellerstellung als erfüllt markieren',

  'form.adv.title': 'Erweiterte Einstellung',
  'form.adv.minPrice': 'Mindestpreis',
  'form.adv.minPriceHelp': 'Der Preis der ersten Variante — die kleinste Gebühr des Plans',
  'form.adv.increment': 'Inkrementbetrag',
  'form.adv.incrementHelp': 'Preisschritt zwischen den generierten Varianten',
  'form.adv.maxPriceLabel': 'Höchstpreis: ',
  'form.adv.explanation': 'Das Planprodukt wird mit {buckets} Varianten generiert: Der Mindestpreis {min} belegt eine Variante, die restlichen {rest} Varianten steigen um {inc}, bis zu einem Höchstpreis von {max}. Beim Checkout zahlt der Kunde die erste Variante, deren Preis bei oder über {pct} % des Warenkorb-Subtotals liegt — ein Warenkorb von $100 bei 2 % zielt auf $2.00, daher greift die Variante zu $3.01. ',
  'form.learnMore': 'Mehr erfahren',

  'form.tiers.title': 'Preis nach Warenkorbwert festlegen',
  'form.tiers.minCol': 'Mindestwarenkorbwert',
  'form.tiers.maxCol': 'Maximaler Warenkorbwert',
  'form.tiers.priceCol': 'Schutzpreis',
  'form.tiers.addTier': 'Neue Stufe hinzufügen',
  'form.tiers.deleteTier': 'Stufe {index} löschen',
  'form.tiers.explanation': 'Jede Regel benötigt einen Mindestwert, einen Höchstwert und einen Preis (Regeln dürfen sich überlappen — die erste passende Regel gilt). Jede Regel wird zu einer eigenen Variante im Planprodukt. Entspricht der Warenkorbwert keiner Regel, gilt der Festpreis aus der Haupteinstellung. ',
  'form.tiers.error.minRequired': 'Mindestwarenkorbwert ist erforderlich',
  'form.tiers.error.maxRequired': 'Maximaler Warenkorbwert ist erforderlich',
  'form.tiers.error.priceRequired': 'Schutzpreis ist erforderlich',
  'form.tiers.error.pricePositive': 'Der Preis muss größer als 0 sein',
  'form.tiers.error.minMax': 'Der Mindestwert muss kleiner oder gleich dem Maximalwert sein',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Nicht gespeicherte Änderungen',
  'savebar.discard': 'Verwerfen',
  'savebar.saving': 'Speichern…',

  // ===== Preview panel =====
  'preview.title': 'Vorschau',
  'preview.simulatedSubtotal': 'Simuliertes Warenkorb-Subtotal',
  'preview.cart': 'Warenkorb',
  'preview.product': 'PRODUKT',
  'preview.total': 'GESAMT',
  'preview.subtotal': 'Zwischensumme',
  'preview.checkout': 'Zur Kasse',
  'preview.noPlans': 'Noch keine aktiven Pläne — Kunden sehen dieses Widget nicht.',
  'preview.autoAdded': 'Automatisch hinzugefügt',
  'preview.unsaved': 'Nicht gespeichert',

  // ===== Settings page =====
  'settings.title': 'Einstellungen',
  'settings.language.title': 'Sprachpräferenz',
  'settings.language.help': 'Wenn Sie FlexCover besuchen, ist dies die Sprache, die Ihnen angezeigt wird. Die Sprache Ihres Shops bleibt unberührt.',
  'settings.language.label': 'Sprache',
  'settings.language.updated': 'Sprache aktualisiert',
  'settings.language.saveFailed': 'Spracheinstellung konnte nicht gespeichert werden: {message}'
};

export default de;
